import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';
import { handleClickSearch, handleKeyDown, query, setSearchQuery, toggleShowSearchResult, } from '../Actions/QuickSearch.action';
import usePrevious from '@react-hook/previous';
import { debounce } from 'lodash-es';
import { Svg } from "./Svg";
// debouncing function to 200ms so we don't send query request on every key stroke
const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);
const QuickSearch = () => {
    const { query, result, showResult, showFullForm, selectedItem, } = useSelector((state) => state.quickSearch);
    const [lastClickedNode, setLastClickedNode] = useState(null);
    const searchUrl = window.__litium.quickSearchUrl +
        (query.length > 0 ? `?q=${query}` : '');
    const searchContainer = useRef(null);
    const searchInput = useRef(null);
    const dispatch = useDispatch();
    const previousSelectedItem = usePrevious(selectedItem);
    const clickHandler = useCallback((event) => {
        if (event.target.classList.contains('js-add-to-cart'))
            return;
        setLastClickedNode(event.target);
    }, []);
    useEffect(() => {
        // listen for click event to hide the search when clicking outside
        window.addEventListener('mousedown', clickHandler);
        return () => window.removeEventListener('mousedown', clickHandler);
    }, [clickHandler]);
    useEffect(() => {
        // set query value if it is avaialble in the Url
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            dispatch(setSearchQuery(query));
        }
    }, [dispatch]);
    useEffect(() => {
        if (selectedItem !== previousSelectedItem) {
            const el = document.querySelector('.quick-search-result__item--selected');
            el &&
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                });
        }
    }, [selectedItem, previousSelectedItem]);
    return (_jsx("div", { role: "search", ref: searchContainer, children: _jsxs("div", { className: `quick-search__form ${showFullForm ? 'quick-search__form--force-show' : ''}`, role: "search", children: [_jsx("input", { className: "quick-search__input", type: "text", placeholder: translate('general.search'), autoComplete: "off", value: decodeURIComponent(query), onChange: (event) => {
                        const text = encodeURIComponent(event.target.value);
                        dispatch(setSearchQuery(text));
                        debouncedQuery(dispatch, text);
                    }, onKeyDown: (event) => dispatch(handleKeyDown(event, { searchUrl })), ref: searchInput, onFocus: () => {
                        if (result && result.length && !showResult) {
                            dispatch(toggleShowSearchResult());
                        }
                    }, onBlur: () => {
                        if (searchContainer.current &&
                            !searchContainer.current.contains(lastClickedNode)) {
                            showFullForm && dispatch(toggleShowSearchResult());
                        }
                    } }), _jsx("button", { className: "quick-search__submit-button", type: "submit", onClick: (e) => {
                        e.preventDefault();
                        dispatch(handleClickSearch({ searchUrl }));
                    }, children: _jsx("i", { className: "quick-search__submit-icon", children: _jsx(Svg, { icon: "magnifying-glass" }) }) }), showResult && (_jsx(QuickSearchResult, { result: result, selectedItem: selectedItem, searchUrl: searchUrl }))] }) }));
};
export default QuickSearch;
